// extracted by mini-css-extract-plugin
export default {"imgBox":"ProductItem_imgBox__316qK","description":"ProductItem_description__LUhc-","name":"ProductItem_name__sXmtB","price":"ProductItem_price__iV7Iy"};